import { useStaticQuery, graphql } from "gatsby";

const useFooterData = () => {
	const { kontentItemFooter } = useStaticQuery(graphql`
		query FooterQuery {
			kontentItemFooter {
				elements {
					logo {
						value {
							url
							width
							height
						}
					}
					links {
						value {
							... on kontent_item_link_group {
								elements {
									title_link {
										value {
											... on kontent_item_link {
												elements {
													text {
														value
													}
													open_in_new_window {
														value {
															codename
														}
													}
													internal_path {
														value
													}
													external_url {
														value
													}
												}
											}
										}
									}
									sub_links {
										value {
											... on kontent_item_link {
												elements {
													text {
														value
													}
													internal_path {
														value
													}
													open_in_new_window {
														value {
															codename
														}
													}
													icon {
														value {
															url
															width
															height
														}
													}
													external_url {
														value
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	`);
  return kontentItemFooter.elements
};

export default useFooterData